// Assets
import Contact from '../../assets/contact.png';
import NoPhoto from '../../assets/no-photo.png';

// Styles
import '../../styles/PeopleCard.css';
import '../../styles/Conversation.css';

// Constants
import { APPROVED } from '../../constants/Constants';

// Utilities
import { getUserTypeLogo } from '../../utils/CommonUtils';

// Types
import { UserProfile } from '../../types/types';

// External Libraries
import { Link } from 'react-router-dom';

// Components
import Text from './Text';
import Button from './Button';

const PeopleCard: React.FC<{
  user: UserProfile;
  onContactClick: (email: string, recipientName: string) => void;
}> = ({ user, onContactClick }) => {
  const handleContactClick = () => {
    if (user.email !== null) {
      onContactClick(user.email, user.first_name);
    }
  };

  return (
    <div className="people-feed-card-containter">
      <Link to={`/profile/${user.id}`} className="redirect-link people-photo">
        <img
          src={
            user.profile_image_url && user.profile_image_url.trim() !== ''
              ? user.profile_image_url
              : NoPhoto
          }
          alt={`${user.first_name}`}
          className="people-photo"
        />
      </Link>
      <div className="people-card-info">
        <Link
          to={`/profile/${user.id}`}
          className="redirect-link people-card-info-sub"
        >
          <Text className="people-card-name">{`${user.first_name} ${user.last_name}`}</Text>
          {user.experiences && user.experiences.length > 0 && (
            <div className="people-card-position">
              {user?.experiences.map((experience, index) => (
                <span key={index}>
                  {experience}
                  {index < user.experiences.length - 1 && ', '}
                </span>
              ))}
            </div>
          )}
        </Link>
        <div>{getUserTypeLogo(user.user_type_id)}</div>
      </div>
      {user.user_status_id === APPROVED &&
        user.admin_status_id === APPROVED && (
          <Button
            type="button"
            onClick={handleContactClick}
            className="contact-container"
          >
            <img src={Contact} alt="Contact" className="contact-logo" />
            Contact
          </Button>
        )}
      {/* <button
        onClick={handleContactClick}
        className={`contact-container ${
          !(user.user_status_id === APPROVED && user.admin_status_id === APPROVED)
            ? 'disabled'
            : ''
        }`}
        disabled={!(user.user_status_id === APPROVED && user.admin_status_id === APPROVED)}
      >
        <img src={Contact} alt="Contact" className="contact-logo" />
        Contact
      </button> */}
    </div>
  );
};

export default PeopleCard;
